<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="company_wrap container">
      <div class="company_title">
        <titleConfig
          :title="langSet == 'cn' ? '展商列表' : 'Exhibitor List'"
          :type="2"
        ></titleConfig>
      </div>
      <div class="active-tab flex flex_content_sb">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            :label="langSet == 'cn' ? '全部' : 'All'"
            :name="'isAll'"
          ></el-tab-pane>
          <template v-for="(item, index) in cateList">
            <el-tab-pane
              :label="langSet == 'cn' ? item.name : item.description"
              :name="String(item.linkageid)"
              :key="index"
            ></el-tab-pane>
          </template>
          <el-tab-pane
            :label="
              langSet == 'cn'
                ? '生物医药供应链'
                : 'Biopharmaceutical Supply Chain'
            "
            :name="'is_biopharmaceutical'"
          ></el-tab-pane>
        </el-tabs>
        <el-input
          class="input"
          prefix-icon="el-icon-search"
          v-model="search.companyName"
          @change="searchHandle"
          placeholder="搜索展商名称"
        ></el-input>
      </div>
      <template v-if="search.productClass1">
        <div class="search-list flex">
          <div class="title-p">
            {{ langSet == "cn" ? currentCate.name : currentCate.description }}
          </div>
          <div class="search-flex flex flex_wrap">
            <div
              class="search-item"
              v-for="(items, indexs) in currentCate.children"
              :key="indexs"
              :class="{ active: search.productClass2 == items.linkageid }"
              @click="tabHandle('productClass2', items.linkageid)"
            >
              {{ langSet == "cn" ? items.name : items.description }}
            </div>
          </div>
        </div>
      </template>
      <template v-if="!isAll && search.productClass1 == ''">
        <div
          class="search-list flex"
          v-for="(item, index) in cateAddList"
          :key="index"
        >
          <div class="title">
            {{ langSet == "cn" ? item.name : item.description }}
          </div>
          <div class="search-flex flex flex_wrap">
            <div
              class="search-item"
              :class="{
                active: search.biopharmaceuticalClass1 == items.linkageid,
              }"
              v-for="(items, indexs) in item.children"
              :key="indexs"
              @click="tabHandle('biopharmaceuticalClass1', items.linkageid)"
            >
              {{ langSet == "cn" ? items.name : items.description }}
            </div>
          </div>
        </div>
      </template>
      <el-table
        :data="list"
        stripe
        style="width: 100%"
        :header-cell-style="{
          background: 'rgba(29,35,121,0.1)',
          color: '#001A33',
        }"
      >
        <el-table-column
          prop="companyName"
          label="公司名称"
          min-width="250"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.companyName }}
            <img
              v-if="scope.row.is_new == 1"
              src="../../assets/icon_new.jpg"
              alt=""
              style="
                width: 46px;
                height: 22px;
                margin-left: 20px;
                position: relative;
                top: 5px;
                display: inline-block;
              "
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="enCompanyName"
          label="COMPANY"
          min-width="300"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          :label="langSet == 'cn' ? '展区' : 'Exhibition Area'"
          min-width="100"
        >
          <template slot-scope="scope">
            {{ langSet == "cn" ? scope.row._showarea : scope.row._showarea_en }}
          </template>
        </el-table-column>
        <el-table-column
          prop="boothNo"
          :label="langSet == 'cn' ? '展位号' : 'Booth No'"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="province"
          :label="langSet == 'cn' ? '省份' : 'Province'"
        >
        </el-table-column>
      </el-table>
      <div class="page_wrap flex flex_content_center">
        <el-pagination
          v-if="totals > 25"
          background
          layout="prev, pager, next"
          :total="totals"
          :current-page="search.pageNo"
          :page-size="15"
          :pager-count="5"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import { getLinkage } from "@/api/api";
import { exhibitorLists } from "@/api/company_api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
  },
  data() {
    return {
      langSet: "",
      metaData: {},
      cateList: [],
      cateAddList: [],
      currentId: "", //选中的分类id
      currentCate: [],
      list: [],
      totals: 0,
      search: {
        productClass1: "",
        productClass2: "",
        companyName: "",
        is_biopharmaceutical: "",
        biopharmaceuticalClass1: "",
        pageNo: 1,
        pageSize: 15,
      },
      isAll: true,
      activeName: "isAll",
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    this.pageNo = 1;
    //25.9.17 获取联动菜单 dxm
    this.getLinkageData("3360,4285");
    this.getList();
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getLinkageData(keyid) {
      let data = {
        keyid,
      };
      const res = await getLinkage(data);
      // 25.9.17 展商筛选分类 dxm
      this.cateList = res.data[3360];
      // 25.9.17 展商筛选分类增加的生物医药供应链分类 dxm
      this.cateAddList = res.data[4285];
    },
    handleClick(tab, event) {
      this.search.productClass2 = "";
      this.search.biopharmaceuticalClass1 = "";
      if (tab.name == "isAll") {
        this.isAll = true;
        this.search.productClass1 = "";
        this.search.is_biopharmaceutical = "";
      } else if (tab.name == "is_biopharmaceutical") {
        this.search.productClass1 = "";
        this.search.is_biopharmaceutical = 1;
        this.isAll = false;
      } else {
        this.search.productClass1 = tab.name;
        this.isAll = false;
        this.search.is_biopharmaceutical = "";
        let currentItem = this.cateList.find(
          (item) => item.linkageid == tab.name
        );
        this.currentCate = currentItem;
      }
      this.search.pageNo = 1;
      this.getList();
    },
    tabHandle(type, id) {
      this.search[type] = this.search[type] == id ? "" : id;
      this.search.pageNo = 1;
      this.getList();
    },
    searchHandle() {
      this.search.pageNo = 1;
      this.getList();
    },
    async getList() {
      let {
        productClass1,
        productClass2,
        is_biopharmaceutical,
        biopharmaceuticalClass1,
        companyName,
        pageNo,
        pageSize,
      } = this.search;
      let data = {
        companyName,
        productClass1,
        productClass2,
        is_biopharmaceutical,
        biopharmaceuticalClass1,
        page_no: pageNo,
        page_size: pageSize,
        initial: "1",
      };
      const res = await exhibitorLists(data);
      this.list = res.data.lists;
      this.totals = res.data.count;
    },
    currentChange(e) {
      this.search.pageNo = e;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-table .el-table__cell {
  font-size: 16px;
  height: 60px;
}
/deep/ .el-table td.el-table__cell {
  border-bottom: 0;
  color: #2c2c2e;
  background: #f7f8fa;
}
/deep/
  .el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td.el-table__cell {
  background: #fff;
}
.company_wrap {
  padding: 80px 0;
  min-height: 600px;
  .company_title {
    margin-bottom: 31px;
  }
  .active-tab {
    margin: 30px 0;
    padding-bottom: 30px;
    border-bottom: 5px solid #eee;
    /deep/ .el-tabs__header {
      margin: 0;
    }
    /deep/ .el-tabs__nav-wrap::after,
    /deep/ .el-tabs__active-bar {
      display: none;
    }
    /deep/ .el-tabs__item {
      font-size: 18px;
      color: #001a33;
      height: 43px;
      padding: 0;
      margin-right: 36px;
      text-align: center;
      font-weight: normal;
      line-height: 43px;
      border-radius: 22px;
      box-sizing: border-box;
      &:last-child {
        margin-right: 0px;
      }
    }
    /deep/ .el-tabs__item.is-active {
      color: #fff;
      padding: 0 20px;
      min-width: 100px;
      background: #1d2379;
    }
    .active {
      color: #fff;
      background: #1d2379;
    }
    .input {
      width: 390px;
      height: 50px;
      /deep/ .el-input__inner {
        height: 50px;
        outline: 0 none;
        line-height: 50px;
        padding-left: 50px;
        border-radius: 30px;
      }
      /deep/ .el-input__prefix {
        font-size: 20px;
        left: 17px;
      }
    }
  }
  .search-list {
    color: #888;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 35px;
    .title {
      width: 190px;
      margin-top: 4px;
    }
    .title-p {
      width: auto;
      margin-top: 4px;
    }
    .search-flex {
      flex: 1;
      padding-left: 50px;
      .search-item {
        height: 28px;
        color: #44435a;
        text-align: center;
        line-height: 28px;
        border-radius: 8px;
        margin-right: 30px;
        margin-bottom: 5px;
        padding: 0 10px;
        cursor: pointer;
      }
      .active {
        min-width: 90px;
        padding: 0 10px;
        background: rgba(29, 35, 121, 0.1);
      }
    }
  }
  .page_wrap {
    margin-top: 40px;
  }
}
@media only screen and (max-width: 1280px) {
  .company_wrap .active-tab {
    padding-bottom: 20px;
  }
  .company_wrap .active-tab .input {
    flex: 1;
    width: auto;
  }
  .company_wrap .active-tab /deep/ .el-tabs__item {
    font-size: 14px;
  }
}
@media only screen and (max-width: 767px) {
  .company_wrap {
    padding: 0.58rem 0;
    .company_title {
      margin-bottom: 0.58rem;
    }
    .active-tab {
      flex-wrap: wrap;
      flex-direction: column-reverse;
      border-bottom: 0;
      padding-bottom: 0;
      .el-tabs {
        width: 100%;
      }
      /deep/ .el-tabs__item {
        min-width: 1.5rem;
        height: 0.56rem;
        margin-right: 0.19rem;
        font-size: 0.23rem;
        line-height: 0.56rem;
        border: 1px solid #eee;
      }
      /deep/ .el-tabs__nav-next,
      /deep/ .el-tabs__nav-prev {
        line-height: 30px;
      }
      .input {
        margin-bottom: 0.33rem;
      }
      .tab-item {
        font-size: 0.23rem;
        height: 0.56rem;
        line-height: 0.56rem;
        border-radius: 20px;
        border: 1px solid #eee;
      }
    }
    .search-list {
      flex-wrap: wrap;
      margin-bottom: 0.3rem;
      .search-flex {
        flex: none;
        width: 100%;
        padding-left: 0;
        padding-top: 0.2rem;
        .search-item {
          margin-right: 0.3rem;
        }
      }
    }
  }
}
</style>